<template>
  <div class="app-container">
    <CommonViewForm :enter="false" @reFresh="reFresh" />
  </div>
</template>
<script>
import CommonViewForm from '../../components/CommonViewForm.vue';
import viewMiXin from '@/utils/view-mixin.js';
export default {
  name: 'BusinessPurchaseReturnInformAdd',
  components: { CommonViewForm },
  mixins: [viewMiXin],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    reFresh() {
      this.complete('BusinessPurchaseReturnInform');
    },
  },
};
</script>
